var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "DAV-dimmed",
    on: {
      "click": _vm.passEmit
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }